export const TAGS_FETCH = 'Tags/FETCH';
export const TAGS_FETCH_SUCCESS = 'Tags/FETCH_SUCCESS';
export const TAGS_FETCH_ERROR = 'Tags/FETCH_ERROR';
